import { Button, Text, useToast } from '@chakra-ui/react';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BsLine } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { lineLogin, lineOnlyLogin } from '../../../api/postApi';

const LineLogin = ({ setButtonLoading, buttonLoading, apiTrigger = false }) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const [searchParams] = useSearchParams();

  const trans_code = searchParams.get('trans_code'); //callback url的trans_code參數名稱為state
  const line_login = searchParams.get('line_login');
  const line_only_login = searchParams.get('line_only_login'); // 判斷是否為僅Line登入
  const invite_code = searchParams.get('invite');
  const line_id = searchParams.get('line_id');
  const line_name = searchParams.get('line_name');

  const dispatch = useDispatch();

  const navigate = useNavigate();

  // 處理 LINE 登入按鈕點擊
  const handleLineLogin = () => {
    window.location.href = `https://liff.line.me/${process.env.REACT_APP_LINE_SIGNIN_LIFF_ID}`;
  };

  useEffect(() => {
    // 判斷是否為僅Line登入模式 如果網址有 line_only_login=true 就走lineOnlyLogin API
    if (line_only_login === 'true') {
      setButtonLoading(true);
      lineOnlyLogin({
        trans_code: trans_code,
        line_id: line_id,
        line_name: line_name
      })
        .then((res) => {
          console.log('LINE only login callback API response', res);
          if (Cookies.get('token')) {
            Cookies.remove('token');
          }
          Cookies.set('token', res.token, { expires: 3 });
          dispatch({ type: 'INITIALIZE_API', navigate: navigate });
          navigate('/');
        })
        .catch((error) => {
          console.error('LINE只用在登入的回調失敗:', error);
        })
        .finally(() => {
          setButtonLoading(false);
        });
    }
    // 原本的Line登入邏輯 如果網址有 line_login=true 就走lineLogin API
    else if (line_login == 'true') {
      setButtonLoading(true);
      lineLogin({
        // code: line_code,
        trans_code: trans_code,
        line_id: line_id,
        invite: invite_code
      })
        .then((res) => {
          console.log('LINE callback API response', res);
          if (Cookies.get('token')) {
            Cookies.remove('token');
          }
          Cookies.set('token', res.token, { expires: 365 });
          dispatch({ type: 'INITIALIZE_API', navigate: navigate });
          navigate('/');
        })
        .catch((error) => {
          console.error('LINE登入回調失敗:', error);
        })
        .finally(() => {
          setButtonLoading(false);
        });
    }
  }, [
    invite_code,
    line_login,
    trans_code,
    line_id,
    line_only_login,
    line_name,
    navigate,
    dispatch,
    setButtonLoading
  ]);

  return (
    <Button
      onClick={handleLineLogin}
      isLoading={buttonLoading}
      w={`100%`}
      display={`flex`}
      alignItems={`center`}
      justifyContent={'center'}
      fontWeight={`medium`}
      bg={`#49C755`}
      py="20px"
      pr="30px"
      type="button"
      id="customBtn"
      color={`white`}
      borderRadius="15px"
      _hover={{
        bg: '#49C755'
      }}
      //href={`https://access.line.me/oauth2/v2.1/authorize?response_type=code&state=${process.env.REACT_APP_WEB_NAME}&redirect_uri=${process.env.REACT_APP_API_URL}/tw/signin&client_id=${process.env.REACT_APP_LINE_CLIENT_ID}&scope=profile&nonce=`}
    >
      <BsLine className="mr-1 text-xl" />
      <Text my="0">{i18n_common('LINElogin')}</Text>
    </Button>
  );
};

export default LineLogin;
